import React, {useEffect} from "react";
import {Image} from "../../../../components/Image";
import "./heroInfoPage.css";

export const HeroInfoPage = ({
    clicked,
    clickNext = () => {},
    isCurPage,
    imageSrc,
    title,
    children,
    pageClassName = ""
}) => {
    useEffect(() => {
        if (clicked && isCurPage) {
            clickNext("continue");
        }
    }, [clicked, clickNext, isCurPage]);

    return (
        <div className={`gallery-page hero-info-page ${pageClassName}`.trim()}>
            <div className="hero-info-photo-wrap">
                <Image
                    src={imageSrc}
                    alt=""
                    className="hero-info-photo"
                    defaultLoad={true}
                />
            </div>

            <div className="hero-info-copy">
                <h1 className="hero-info-title">{title}</h1>
                <div className="hero-info-body">
                    {children}
                </div>
            </div>
        </div>
    );
};
